import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { Dropdown } from "primeng/dropdown";

import { DataService_itemcollection } from "../shared/data.service";
import { PersonSelectorService } from "../../../personselector/personselector.service";

import { wsItemCollectionStaffAddEditInfoParm } from "../shared/wsItemCollectionStaffAddEditInfo";
import { wsItemCollectionStaffAddEditInfo } from "../shared/wsItemCollectionStaffAddEditInfo";
import { ScanPersonalItemClassInfo } from "../shared/wsItemCollectionStaffAddEditInfo";
import { ScanPersonalItemConditionInfo } from "../shared/wsItemCollectionStaffAddEditInfo";

import { wsItemCollectionStaffAddEditUpdateInfoParm } from "../shared/wsItemCollectionStaffAddEditInfo";

@Component({
	selector: "app-root",
	templateUrl: "./itemcollectionaddedit.component.html",
	styleUrls: ["./itemcollectionaddedit.component.css"],
	providers: [ConfirmationService],
})
export class ItemCollectionAddEditComponent implements OnInit, OnDestroy {
	constructor(
		private dataService: DataService_itemcollection,
		private personselectorService: PersonSelectorService,
		public ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		public dialogConfig: DynamicDialogConfig
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isBusy: boolean = false;
	public isEditMode: boolean = false;

	//	Person Selector
	private subscriptionPersonSelect: Subscription;
	public SelectedPerson: any; // From Person Selector

	public ItemCollectionStaffAddEditInfo: wsItemCollectionStaffAddEditInfo =
	{
		ScanPersonalItemID: "",
		PersonID: -1,
		StaffID: "",
		FullName: "",
		Log_PersonID: -1,
		LogByFullName: "",
		ScanPersonalItemClassID: -1,
		ScanPersonalItemConditionID: -1,
		BinNumber: "",
		ScanPersonalItemDesc: "",
		CollectionDTDesc: "",
		Returned: "",
		ChangedByFullName: "",
		ChangedDTDesc: "",
		ScanPersonalItemClassItems: [],
		ScanPersonalItemConditionItems: []
	}; // For HTML to not error on init
		
	public lstScanPersonalItemClass: ScanPersonalItemClassInfo[] = [];
	public SelectedScanPersonalItemClass: ScanPersonalItemClassInfo = 
	{
		ScanPersonalItemClassID: -1,
		ScanPersonalItemClassDesc: "",
	}; // For HTML to not error on init

	public lstScanPersonalItemCondition: ScanPersonalItemConditionInfo[] = [];
	public SelectedScanPersonalItemCondition: ScanPersonalItemConditionInfo = {
		ScanPersonalItemConditionID: -1,
		ScanPersonalItemConditionDesc: "",
	}; // For HTML to not error on init

	//	Error Messaging
	public ErrorMessage: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.isBusy = true;

		//
		//	Init Person Selector
		//
		this.subscriptionPersonSelect = this.personselectorService.onPersonSelectChange().subscribe((person) => {
			this.SelectedPerson = person;
		});		

		let parm: wsItemCollectionStaffAddEditInfoParm = 
		{
			ScanPersonalItemID: this.dialogConfig.data.ScanPersonalItemID
		};		

		if (parm.ScanPersonalItemID.length == 0) 
		{	
			this.isEditMode = false;
		}
		else
		{
			this.isEditMode = true;
		}

		this.isBusy = true;
		this.dataService.ItemCollectionStaffAddEditGetData(parm).subscribe((data) => this.ItemCollectionStaffAddEditGetData_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() 
	{
		this.subscriptionPersonSelect.unsubscribe();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ItemCollectionStaffAddEditGetData_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	ItemCollectionStaffAddEditGetData_Complete(data: any) {

		this.ItemCollectionStaffAddEditInfo = data;

		this.lstScanPersonalItemClass = this.ItemCollectionStaffAddEditInfo.ScanPersonalItemClassItems;
		this.lstScanPersonalItemCondition = this.ItemCollectionStaffAddEditInfo.ScanPersonalItemConditionItems;

		//
		//	Select Default ScanPersonalItemClass
		//
		this.SelectedScanPersonalItemClass = this.lstScanPersonalItemClass[0];

		this.lstScanPersonalItemClass.forEach((item) => {
			if (item.ScanPersonalItemClassID == this.ItemCollectionStaffAddEditInfo.ScanPersonalItemClassID) {
				this.SelectedScanPersonalItemClass = item;
			}
		});

		//
		//	Select Default ScanPersonalItemCondition
		//
		this.SelectedScanPersonalItemCondition = this.lstScanPersonalItemCondition[0];

		this.lstScanPersonalItemCondition.forEach((item) => {
			if (item.ScanPersonalItemConditionID == this.ItemCollectionStaffAddEditInfo.ScanPersonalItemConditionID) {
				this.SelectedScanPersonalItemCondition = item;
			}
		});

		//
		//	Are We in Add mode?
		//
		if (this.isEditMode == false)
		{
			this.ItemCollectionStaffAddEditInfo.Log_PersonID = this.dialogConfig.data.Log_PersonID;
			this.ItemCollectionStaffAddEditInfo.LogByFullName = this.dialogConfig.data.LogByFullName;
			this.ItemCollectionStaffAddEditInfo.BinNumber = "";
			this.ItemCollectionStaffAddEditInfo.ScanPersonalItemDesc = "";
		}

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onPersonalItemClassChange
	//
	//-----------------------------------------------------------------------------------------------------
	onPersonalItemClassChange(e: any) {
		//
		//	Select Default PersonalItemClass
		//
 		this.lstScanPersonalItemClass.forEach((item) => {
			if (item.ScanPersonalItemClassID == this.SelectedScanPersonalItemClass.ScanPersonalItemClassID) {
				this.SelectedScanPersonalItemClass = item;
			}
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onScanPersonalItemConditionChange
	//
	//-----------------------------------------------------------------------------------------------------
	onScanPersonalItemConditionChange(e: any) {
		//
		//	Select Default PersonalItemCondition
		//
		this.lstScanPersonalItemCondition.forEach((item) => {
			if (item.ScanPersonalItemConditionID == this.SelectedScanPersonalItemCondition.ScanPersonalItemConditionID) {
				this.SelectedScanPersonalItemCondition = item;
			}
		});	
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAddUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	onAddUpdate() {
		this.ErrorMessage = "";

		//
		//	Validate
		//
		if (this.SelectedScanPersonalItemClass.ScanPersonalItemClassID < 1) {
			this.ErrorMessage = "Invalid Class.";
			return;
		}

		if (this.SelectedScanPersonalItemCondition.ScanPersonalItemConditionID < 1) {
			this.ErrorMessage = "Invalid Condition.";
			return;
		}

		if (this.isEditMode == false && this.SelectedPerson.PersonID < 1) 
		{
			this.ErrorMessage = "Please select a Staff.";
			return;
		}

		//
		//	Validate Passed / Do the Update
		//
		let parm: wsItemCollectionStaffAddEditUpdateInfoParm = 
		{
			ScanPersonalItemID: "",
			PersonID: -1,
			Log_PersonID: -1,
			ScanPersonalItemClassID: -1,
			ScanPersonalItemConditionID: -1,
			BinNumber: "",
			ScanPersonalItemDesc: ""
		};

		if (this.isEditMode == true) 
		{
			parm.ScanPersonalItemID = this.ItemCollectionStaffAddEditInfo.ScanPersonalItemID;
			parm.PersonID = this.ItemCollectionStaffAddEditInfo.PersonID;
			parm.Log_PersonID = this.dialogConfig.data.Log_PersonID;
			parm.ScanPersonalItemClassID = this.SelectedScanPersonalItemClass.ScanPersonalItemClassID;
			parm.ScanPersonalItemConditionID = this.SelectedScanPersonalItemCondition.ScanPersonalItemConditionID;
			parm.BinNumber = this.ItemCollectionStaffAddEditInfo.BinNumber;
			parm.ScanPersonalItemDesc = this.ItemCollectionStaffAddEditInfo.ScanPersonalItemDesc;
		}
		else
		{
			parm.ScanPersonalItemID = "";
			parm.PersonID = this.SelectedPerson.PersonID;		// From Person Selector
			parm.Log_PersonID = this.ItemCollectionStaffAddEditInfo.Log_PersonID;
			parm.ScanPersonalItemClassID = this.SelectedScanPersonalItemClass.ScanPersonalItemClassID;
			parm.ScanPersonalItemConditionID = this.SelectedScanPersonalItemCondition.ScanPersonalItemConditionID;
			parm.BinNumber = this.ItemCollectionStaffAddEditInfo.BinNumber;
			parm.ScanPersonalItemDesc = this.ItemCollectionStaffAddEditInfo.ScanPersonalItemDesc;
		}

		this.isBusy = true;
		this.dataService.ItemCollectionStaffAddEditUpdate(parm).subscribe((data) => this.ItemCollectionStaffAddEditUpdate_Complete(data));		
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ItemCollectionStaffAddEditUpdate_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	ItemCollectionStaffAddEditUpdate_Complete(data: any) {
		this.isBusy = false;
		this.ErrorMessage = data[0];

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.ErrorMessage.length == 0) {
			this.ref.close(1);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}
}
